import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function PolazisteIcon(props: SvgIconProps) {
  return <SvgIcon {...props}>
    <svg version="1.1" id="PolazisteIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fill="currentcolor" d="M50,27.442c-12.682,0-23,10.318-23,23c0,10.498,7.072,19.369,16.7,22.115l1.299-4.559
	c-7.647-2.182-13.268-9.219-13.268-17.556c0-10.074,8.196-18.269,18.269-18.269s18.269,8.196,18.269,18.269
	c0,8.338-5.621,15.374-13.268,17.556l1.299,4.559C65.928,69.811,73,60.94,73,50.443C73,37.76,62.682,27.442,50,27.442z"/>
      <circle fill="currentcolor" cx="50" cy="50.442" r="10.569"/>
    </svg>
  </SvgIcon>
}

export default PolazisteIcon;
